
import { defineComponent, ref } from "vue";
import UserColumns from "~/components/UserAccounts/UserColumns.vue";
import UserCorporateLayout from "~/components/UserAccounts/UserCorporateLayout.vue";

export default defineComponent({
  name: "UserColumnsPage",
  components: {
    UserCorporateLayout,
    UserColumns
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const loading = ref(true);
    return {
      loading,
    };
  }
});
